import okaTool from './okaTool.js'

let $_extend = (validator) => {
    
    validator.extend('isAfter', (endTime, [startTime]) => {
        return okaTool.timeValidate(endTime, startTime, '>');
    }, {
        hasTarget: true
    });
    
    validator.extend('equalAfter', (endTime, [startTime]) => {
        return okaTool.timeValidate(endTime, startTime, '>=');
    }, {
        hasTarget: true
    });
    
    validator.extend('isBefore', (endTime, [startTime]) => {
        return okaTool.timeValidate(endTime, startTime, '<');
    }, {
        hasTarget: true
    });
    
    validator.extend('equalBefore', (endTime, [startTime]) => {
        return okaTool.timeValidate(endTime, startTime, '<=');
    }, {
        hasTarget: true
    });

    validator.extend('notInclude', (value, [val]) => { //限制字串最小bytes
        let _val = val.toUpperCase(),
            _value = value.toUpperCase();

        if( _value === _val ) {
            return false;
        }else {
            return true;
        }
    });

    validator.extend('max_bytes', (value, [length]) => { //限制字串最大bytes
        let _length = length || -Infinity,
            $dots = encodeURI(value).split(/%..|./).length - 1;

        return $dots <= _length;
    });

    validator.extend('multiple_of', (value, [val]) => { //倍數
        let _val = parseFloat(val),
            _value = parseFloat(value);
            
        if( _value % _val ) {
            return false;
        }else {
            return true;
        }
    });
}

export default $_extend;
